<template>
    <ServiceDetailComponent/>
    <RelatedDoctorComponent/>
    <ServiceRelatedComponent/>
</template>

<script setup>
    import ServiceDetailComponent from '@/components/services/ServiceDetailComponent.vue';
    import RelatedDoctorComponent from '@/components/services/RelatedDoctorComponent.vue';
    import ServiceRelatedComponent from '@/components/services/ServiceRelatedComponent.vue';
    scrollTo(0, 0);
</script>

<style scoped>
    /*  */
</style>